
import {
	Component,
	Vue
} from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue'
import PickerDate from '@/components/picker-date.vue';
import {
	getProductSalesStatistics,
	productspecSellStatis
} from '@/api/statistic'
import {
	productCategory,
	providerSelectItem
} from '@/api/supplier';
import {
	getSearchDate,
	nextDay
} from "@/utils/index"
import {
	productBuyerproductBuyerPageInit,
	productOpenTimeLabelFilterList
} from "@/api/supplier"
@Component({
	name: 'product-sales',
	components: {
		PageFooter,
		PickerDate
	}
})
export default class ProductSales extends Vue {
	private filterTime: any = []
	private productNameKey = ''
	private list: any = []
	private pageNo = 1;
	private pageSize = 10;
	private total = 0;
	private tableloading = false
	private lazyloading = false
	private totallist: any = []

	private openTimeLabel = '';
	private openTimeLabelList: any = [];

	private categoryList: any = [];
	private categoryId = '';
	private supplierNameKey = '';
	private supplierList: any = []
	private defaultsort: any = {
		prop: 'ProductId',
		order: 'descending'
	}
	private purchaselist: any = []
	private ProductBuyerId = null

	// private activated () {
	// 	this.initTime()
	// 	// console.log(getSearchDate(2,false,-6),getSearchDate(2))
	// 	this.getList();
	// }

	mounted() {
		this.initTime()
		this.getSupplierList()
		this.getProductCategory()
		this.getpurchaseList()
		this.getOpenTimeLabel();
		this.getList();

	}



	private async getpurchaseList() {
		try {
			let res: any = await productBuyerproductBuyerPageInit({
				Skip: 0,
				Take: 999999
			})
			if (res.IsSuccess) {
				this.purchaselist = res.Result.Results.map(v => {
					return {
						value: v.Id,
						label: v.BuyerName
					}
				})
			}
		} finally {
			//
		}
	}
	private sortmethod(e) {
		this.defaultsort = {
			prop: e.prop,
			order: e.order
		}
		this.getList()
	}
	// 获取供应商列表
	private async getSupplierList() {
		try {
			const res: any = await providerSelectItem({});
			this.supplierList = res.Result.map(v => {
				return {
					value: v.Id,
					label: v.ProviderName
				}
			})
		} catch (e) {
			console.log('supplierList ===>', e);
		}
	}

	/**
	 * 获取商品分类
	 */
	private async getProductCategory() {
		try {
			const res: any = await productCategory({
				Skip: 0,
				Take: 999999,
			});
			this.categoryList = res.Result.Results.map(item => {
				return {
					value: item.Id,
					label: item.CategoryName
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}
	/**
	 * 获取开团日期标签
	 */
	private async getOpenTimeLabel(){
		try {
			const res: any = await productOpenTimeLabelFilterList({
				Skip: 0,
				Take: 999999,
			});
			this.openTimeLabelList = res.Result.map((item, i)=>{
				return {
					value: i,
					label: item.OpenTimeLabel
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}
	
	private initTime() {
		this.filterTime = [getSearchDate(2, true)[0], getSearchDate(2, true)[1]]
	}

	private getrowkey(row) {
		// console.log(row)
		return row.Id
	}

	private handleClickRow(scope: any) {
		// console.log(scope)
		if (scope.row.ProductId === '总计') return
		if (scope.row.Open) {
			this.$nextTick(() => {
				const $table: any = this.$refs.table
				$table.toggleRowExpansion(scope.row)
				scope.row.Open = !scope.row.Open
			})
			return
		}
		this.getdetail(scope)
	}

	private async getdetail(scope) {
		this.lazyloading = true
		try {
			let data: any = {
				ProductId: await scope.row.ProductId,
				SpecValue: scope.row.IsIncludedSubmitOrderInfo ? scope.row.SpecValue : ''
			}
			if (this.filterTime && this.filterTime.length) {
				data.StartTime = this.filterTime[0]
				data.EndTime = this.filterTime[1];//nextDay(this.filterTime[1], 1)
			}
			// console.log(scope)
			let res = await productspecSellStatis(data)
			if (res.IsSuccess) {
				// console.log(res.Result)
				this.list = this.list.map((v, i) => {
					if (v.ProductId == scope.row.ProductId && scope.row.Id == v.Id) {
						v.ProductSpecSellStatisList = res.Result.map(x => {
							x.Id = v.ProductId + Math.random() + 'child'
							x.IsMain = false
							x.ProductType = v.ProductType
							return x
						})
						// console.log(v.ProductSpecSellStatisList.map(b=>b.Id))
					}
					return v
				})
				// console.log((this.list.map(v=>v.Id)))
				this.$nextTick(() => {
					const $table: any = this.$refs.table
					$table.toggleRowExpansion(scope.row)
					scope.row.Open = !scope.row.Open
				})
			}
		} finally {
			this.lazyloading = false
		}
	}

	private changePage(num: number) {
		this.pageNo = num;
		this.getList();
	}

	private exportlist() {
		let url = location.origin + '/pc/product/sellStatisExport' +
			'?Keywords=' + (this.productNameKey ? this.productNameKey : '') +
			'&ProviderId=' + (this.supplierNameKey ? this.supplierNameKey : '') +
			'&ProductCategoryId=' + (this.categoryId ? this.categoryId : '') +
			'&ProductBuyerId=' + (this.ProductBuyerId == null ? '' : this.ProductBuyerId)

		if (this.filterTime && this.filterTime.length) {
			url += '&StartTime=' + (this.filterTime[0] ? this.filterTime[0] : '')
			url += '&EndTime=' + (this.filterTime[1] ? this.filterTime[1] : '');
		}
		if (this.openTimeLabelList[this.openTimeLabel]?.label){
			url += '&OpenTimeLabel=' + this.openTimeLabelList[this.openTimeLabel]?.label
		}
		// console.log(url)ProductBuyerId
		window.open(url)
	}

	private async getList() {
		let params: any = {
			// Skip: (this.pageNo-1)*this.pageSize,
			// Take: this.pageSize,
			Keywords: this.productNameKey,
			ProviderId: this.supplierNameKey,
			ProductCategoryId: this.categoryId,
			ProductBuyerId: this.ProductBuyerId,
			OpenTimeLabel: this.openTimeLabelList[this.openTimeLabel]?.label
		}
		if (this.filterTime && this.filterTime.length) {
			params.StartTime = this.filterTime[0]
			params.EndTime = this.filterTime[1];
		}
		this.tableloading = true
		try {
			const res: any = await getProductSalesStatistics(params);
			// console.log(res)
			if (!res.Result.Result.Total) {
				this.list = []
				this.total = 0
				this.totallist = []
				return
			}

			let list = res.Result.Result.Results.map(v => {
				v.IsOpen = false
				v.Open = false
				v.IsMain = true
				v.Id = v.ProductId + Math.random() + 'main'
				return v
			})
			this.totallist = [{ ...res.Result.TotalStatistic, ProductId: '总计', IsMain: true, Id: '0main' }]
			this.list = list.sort((a, b) => {
				if (this.defaultsort.order == 'ascending') {
					return a[this.defaultsort.prop] - b[this.defaultsort.prop]
				} else if (this.defaultsort.order == 'descending') {
					return b[this.defaultsort.prop] - a[this.defaultsort.prop]
				}
			})
			// this.total = res.Result.Result.Total;
			// console.log(this.list)
		} catch (e) {
			console.log(e)
		} finally {
			this.tableloading = false
		}
	}

	private doSearch() {
		this.pageNo = 1;
		this.getList();
	}

	private clearSearch() {
		// this.filterTime = getSearchDate(1);
		this.initTime()
		this.openTimeLabel = ''
		this.productNameKey = '';
		this.supplierNameKey = null
		this.categoryId = null
		this.getList();
	}
}
